import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import classNames from 'classnames';

import Form from './Form';
import dialogBackgroundImage from '../../images/form_bg.jpg';
import './input.css';

const useStyles = makeStyles({
  dialogRoot: {
    margin: 'auto'
  },
  paper: {
    background: `url(${dialogBackgroundImage})`,
    width: '100vw',
    height: '100vh',
    maxWidth: '100vw',
    maxHeight: '100vh',
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  dialogContent: {
    maxWidth: '600px',
    flex: 'unset'
  },
  dialogActions: {
    background: 'transparent',
    position: 'absolute',
    color: 'white',
    top: 0,
    right: 0
  },
  button: {
    position: 'fixed',
    zIndex: 1,
    left: 0,
    top: 0,
    margin: '20px 180px',
    padding: '7px 25px',
    border: 0,
    borderRadius: '6px',
    background: '#9EC73C !important',
    transition: '.3s ease all',
    '&:hover': {
      opacity: 0.8
    }
  },
  buttonTablet: {
    bottom: '0px',
    left: '0px',
    margin: '20px',
    width: '240px',
    top: 'unset'
  },
  buttonMobile: {
    bottom: '0px',
    left: 0,
    margin: '20px 10px',
    width: '255px',
    top: 'unset'
  }
});

function SimpleDialogBody(props) {
  const { onClose, open } = props;
  const classes = useStyles();

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      aria-labelledby="simple-dialog-title"
      open={open}
      className={classes.dialogRoot}
      classes={classes}
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      <DialogContent className={classes.dialogContent}>
        <Form onComplete={handleClose} />
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <IconButton onClick={handleClose} color="inherit">
          <CloseIcon />
        </IconButton>
      </DialogActions>
      <div className={classes.dialogInner}></div>
    </Dialog>
  );
}

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired
};

export default function SimpleDialog() {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const isDesktopOrTablet = useMediaQuery(theme.breakpoints.up('sm'));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
  };

  return (
    <div>
      <Button
        onClick={handleClickOpen}
        className={classNames(classes.button, {
          [classes.buttonTablet]: !isDesktop,
          [classes.buttonMobile]: !isDesktopOrTablet
        })}
      >
        DOWNLOAD City Scores
      </Button>
      <SimpleDialogBody open={open} onClose={handleClose} />
    </div>
  );
}
